import { ReactNode } from 'react';
import { useDarkMode, toContrastColor, toAlertBg, toAlertBorder } from '../context/DarkModeContext';
import classnames from '../util/classnames';

type FilterChipProps = {
  color: string;
  active: boolean;
  onClick: () => void;
  children: ReactNode;
  className?: string;
  pill?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export default function FilterChip({ color, active, onClick, children, className, pill = false, ...rest }: FilterChipProps) {
  const { isDarkMode } = useDarkMode();

  const resolvedColor = isDarkMode ? toContrastColor(color) : color;
  const bg = active ? (isDarkMode ? toAlertBg(color) : `${color}18`) : 'transparent';
  const border = isDarkMode ? toAlertBorder(color) : color;

  return (
    <button
      type="button"
      className={classnames(`remarks-filter-chip flex gap-1 items-center${className ? ` ${className}` : ''}`, {
        ['remarks-filter-chip--pill']: pill,
      })}
      style={{
        borderColor: border,
        backgroundColor: bg,
        color: resolvedColor,
        opacity: active ? 1 : 0.6,
        fontWeight: active ? 600 : 400,
      }}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
}
